/** @format */
import "./App.css";
import { Header } from "./components/Header";
import { Main } from "./components/Main";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="scroll-smooth">
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
